import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import { twitterHandle, titlePrefix } from './seo.constants';
import { getPageMeta } from './seo.helper';

function SEO({ pageName, lang, meta, pageData }) {
  const pageMeta = getPageMeta(pageName, pageData);
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={pageMeta.title}
      titleTemplate={`${titlePrefix} | %s`}
      meta={[
        {
          name: `description`,
          content: pageMeta.description,
        },
        {
          property: `og:title`,
          content: pageMeta.title,
        },
        {
          name: `og:url`,
          content: pageMeta.postLink,
        },
        {
          name: `og:image`,
          content: pageMeta.image,
        },
        {
          property: `og:description`,
          content: pageMeta.description,
        },
        {
          property: `og:type`,
          content: pageMeta.facebookCardType,
        },
        {
          name: `twitter:card`,
          content: pageMeta.twitterCardType,
        },
        {
          name: `twitter:creator`,
          content: twitterHandle,
        },
        {
          name: `twitter:site`,
          content: twitterHandle,
        },
        {
          name: `twitter:title`,
          content: pageMeta.title,
        },
        {
          name: `twitter:image`,
          content: pageMeta.image,
        },
        {
          name: `twitter:description`,
          content: pageMeta.description,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
};

SEO.propTypes = {
  pageName: PropTypes.string.isRequired,
  pageData: PropTypes.object,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
